import { Component, Inject, OnDestroy, OnInit, Input, ViewChild } from '@angular/core';
import { Store } from '@src/store';
import { projectActions } from "../../../../store/reducers/projectReducer";
import { ManageEnvironmentTypesDialogComponent } from "@app/shared/components/dialogs/manage-environment-types-dialog/manage-environment-types-dialog.component";
import { projectsActions } from '../../../../store/reducers/projectsReducer';
import { licenseActions } from '../../../../store/reducers/licenseReducer';
import { DialogManagerService, SessionService } from '@src/services';
import _ from 'lodash';
import * as _str from 'underscore.string';
import { consts } from '@src/constants/consts';
import { ProcessesHoverViewComponent } from './processesHoverView-ang7/processesHoverView';
//import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
    selector: 'pipeline',
    template: require('./pipleline-ang7.html'),
    styles: [require('./_pipeline.scss')]
})

export class PiplineComponent implements OnInit, OnDestroy {

    @Input() public projectData;
    @Input() public set environments(value) {
        this._environments = _.orderBy(value, ['name'], ['asc']);
    }
    @Input() public pipelineConfig: any;

    @ViewChild(ProcessesHoverViewComponent) childRef: ProcessesHoverViewComponent;

    public envConfig = {
        showMenu: true,
        showVersion: true,
        showDateTime: true,
        showStatus: true
    };
    public connectionStatusesTexts = {
        GOOD: "Online",
        WARNING: "Warning",
        BAD: "Offline"
    };
    public connectionStatuses = {
        GOOD: "GOOD",
        WARNING: "WARNING",
        BAD: "BAD",
    };
    public isHideManageEnvTypes: string = 'false';
    public _environments: any
    public packagesData: any
    public connectionState: any = this.connectionStatuses.GOOD;;
    public firstTimeOnEditMode: any;
    public undoChangesFlag: boolean;
    public pageId = 1;
    public currEnvTypeIndex: any = 0;
    public resetMainScripts: boolean;
    public rmId: any;
    public quantity = 15;
    public onProcessUpdateReceivedData;
    public autoBackupsItems = [];
    public autoRestoreItems = [];
    public autoRestoreSelected;
    public boxes;
    public processConnectionState: any;
    public destroyed;
    public envs;
    public autoBackupSelected;
    public defaultBackup;
    public continouesErrorCount: number = 0;
    public m_getEnvTypes: any;
    public defaultAutoRestore;
    public dbFlags;
    public projectId: any;
    public jobId: any;
    public showSchemaSettings: any;
    public _envTypes: any;
    public unSubscribe: any;
    public unSubscribeEditMode: any;
    public UseDowngradeScripts: boolean = true;
    public scrollEnvs;
    public envTypeTest: any
    public $translate: any;


    constructor(@Inject('processDetailsModalService') private processDetailsModalService: any, @Inject('$filter') private $filter: any, @Inject('projectsLocalHistoryService') private projectsLocalHistoryService: any,
        @Inject('logsLocalHistoryService') private logsLocalHistoryService: any, @Inject('jobCompletitionService') private jobCompletitionService: any
        , private sessionService: SessionService, private dialogManagerService: DialogManagerService, @Inject('$scope') public $scope: any, public store: Store, @Inject('$state') public state: any, @Inject('$stateParams') public $stateParams: any) {
        this.projectId = this.$stateParams.id;
        this.jobId = this.$stateParams.jobId;
        this.$translate = this.$filter('translate');
        this.m_getEnvTypes = this.jobCompletitionService.m_getEnvTypes.bind(this);
        this.onProcessUpdateReceivedData = this.jobCompletitionService.onProcessUpdateReceivedData.bind(this);
        this.m_getEnvTypes();
        this.store.dispatch({ type: projectsActions.GET_PROJECT_META_DATA, payload: { projId: this.projectId } });
        this.store.dispatch({ type: projectActions.HIDE_MANAGE_ENVIRONMENT_ON_EDIT_MODE, payload: { hideManageEnv: "false" } });

        var name = this.sessionService.get(`project_${$stateParams.id}`);

        if (name && !name.match(/.*\(Draft\)$/))
            this.projectsLocalHistoryService.AddProjectHistory({ id: parseInt(this.projectId), name: name, isDraft: false }, this.state.$current.locals.globals.userDetails.data.id);

    }


    showJobDialog(jobId) {
        if (jobId != null) {
            //const data = { JobQId: jobId, activityIcon: this.getImage(this.item.type) };
            const data = { JobQId: jobId, activityIcon: 0 };
            this.processDetailsModalService.OpenProcessDetailsModal(data, true);
        }
    }
    destroyChild() {
        if (this.childRef) {
            this.childRef.ngOnDestroy();
        }
    }

    ngAfterViewInit() {
        if (this.jobId != null && this.jobId != '')
            this.showJobDialog(this.jobId);

    }

    ngOnInit() {
        this.unSubscribeEditMode = this.store.subscribe(_ => {
            const proj = this.store.getState().project;
            if (proj.editMode && (!proj.projectBeforeEdit || Object.keys(proj.projectBeforeEdit).length === 0) && this.store.getState().project.data) {
                this.store.dispatch({
                    type: projectActions.SAVE_PROJECT_BEFORE_EDIT,
                    payload: this.store.getState().project.data
                })
            }
        });

        this.unSubscribe = this.store.subscribe(() => {
            if (this.store.getState().project.editActions &&
                (this.store.getState().project.editActions.state.current.name == 'app.authorized.environments'
                    || this.store.getState().project.editActions.state.current.name == 'app.authorized.packages'
                    || this.store.getState().project.editActions.state.current.name == 'app.authorized.taskManager')) {
                this.projectData = this.store.getState().project.data;
                if (this.projectData)
                    this.projectData.id = this.$stateParams.id;
                switch (this.store.getState().project.editActions.action) {
                    case 'saveChange': {
                        this.saveChanges();
                        break;
                    }
                    case 'undo': {
                        this.undoChanges();
                        break;
                    }
                    case 'saveDraft': {
                        this.saveDraft();
                        break;
                    }
                    case 'validtion': {
                        break;
                    }
                    case 'manageEnv': {
                        this.onManageEnvTypes();
                        break;
                    }
                }
                this.store.dispatch({
                    type: projectActions.ACTION_CLEAR,
                })
            }
        });

        this.$scope.$watch(() => this.store.getState().project.data, (newVal, oldVal) => {
            if (oldVal) { }
            if (!newVal)
                return;

            this.projectData = newVal;
            if (this.projectData != null &&
                this.projectData.parentId == null &&
                this.projectData.userInitiatedChange &&
                this.store.getState().project.mainScriptsSourcePath &&
                this.resetMainScripts) {
                //_this.projectData.options['ScriptOutputFolder'] = _this.store.getState().project.mainScriptsSourcePath;
                this.resetMainScripts = false;
            }
        });
    }

    get envTypes() {
        if (this.store && this.store.getState().project.editMode && this.projectData) {
            this.envTypeTest = this.projectData.environmentTypes.filter(item => item.id == 8)[0]
            this.envs = this.projectData.environmentTypes.filter(item => item.selected && item.id != 8) //without test
            return this.envs;
        }
        if (this._envTypes) {
            if (!this.envTypeTest) {
                this.envTypeTest = this._envTypes.filter(item => item.id == 8)[0];
            }

            if (this.projectData && this._envTypes.length == 0)
                this._envTypes = this.projectData.environmentTypes.filter(item => item.selected && item.id != 8);
            else
                this._envTypes = this._envTypes.filter(item => item.id != 8);
        }

        this.getRmID();
        return this._envTypes
    }

    set envTypes(data) {
        this._envTypes = data;
    }

    connectionStateReset() {
        this.continouesErrorCount = 0;
        this.connectionStateUpdate();
    }

    setProcessConnectionStatus = (data) => {
        this.processConnectionState = data.data;
    }

    connectionStateAddError() {
        this.continouesErrorCount++;
        this.connectionStateUpdate();
    }

    updateJobCompletionPercentage(execJob) {
        let jobCompletionPercentage = [...this.store.getState().jobs.jobCompletionPercentage || []];
        let newJobCompletion = { jobId: execJob.JobQId, completionPercentage: execJob.PercentageComplete };

        if (jobCompletionPercentage.find(job => job.jobId == execJob.JobQId))
            return jobCompletionPercentage.map(job => job.jobId == execJob.JobQId ? newJobCompletion : job);
        return [...jobCompletionPercentage, newJobCompletion];
    }

    connectionStateUpdate() {
        if (this.continouesErrorCount > 5) {
            this.connectionState = this.connectionStatuses.BAD;
        } else if (this.continouesErrorCount > 0) {
            this.connectionState = this.connectionStatuses.WARNING;
        } else {
            this.connectionState = this.connectionStatuses.GOOD;
        }
    }

    goEnv(data, envIndex) {
        if (!this.store.getState().project.editMode)
            var env = this._envTypes[envIndex].environments.find(item => item.id == data.id)
        this.state.go(`app.authorized.environment.activities`, {
            id: this.projectId,
            envID: data.id,
            envName: (env) ? env.name : data.name
        });
    }

    getRmID(item: any = "false") {
        if (item == "true") { }
        let result;
        if (this._envTypes) {
            this._envTypes.forEach(env => {
                if (env.flowType == 0) {
                    result = env.environments[0].id;
                }
            });
        }
        this.rmId = result;
        return result;
    }

    UpdateEnvType = (envType, targetEnvName, execJob) => {
        envType.environments.forEach((env) => {
            if (env.name === targetEnvName.trim()) {
                env.percentageComplete = execJob.PercentageComplete;
            }
        });
    };

    undoChanges() {
        this.undoChangesFlag = true;
        if (this.store.getState().project.projectBeforeEdit) {
            let parentId = this.projectData.parentId;
            this.projectData = { ...this.store.getState().project.projectBeforeEdit };
            if (!this.projectData.parentId)
                this.projectData.parentId = parentId;
        }
        if (this.projectData && !this.projectData.parentId) {
            this.store.dispatch({ type: projectActions.GET_EDIT_PROJECT, payload: { projectId: this.state.params.id } });
        }

        this.onClose();

        this.store.dispatch({ type: projectActions.ACTION_CLEAR });
        this.store.dispatch({ type: projectActions.SET_EDIT_MODE, payload: { editMode: false } });

        //for continue timeout
        if (this.firstTimeOnEditMode)
            this.firstTimeOnEditMode = false;
        this.m_getEnvTypes();

        //delete draft by server - see submenu.js
        if (this.store.getState().project.isNewDraft) {
            this.store.dispatch({ type: projectsActions.DELETE_DRAFT, payload: { id: this.state.params.id } });
            this.store.dispatch({
                type: projectActions.SET_EDIT_MODE,
                payload: {
                    editMode: false,
                    isNewDraft: null,
                    isNew: null
                }
            });
        }
        this.state.go('app.authorized.environments', { id: this.projectData.parentId, name: this.projectData.name });
    }

    hasAutoDrift(envType) {
        if (this.store.getState().projects.projectWithMetaData) {
            //window.dbTypeId = this.store.getState().projects.projectWithMetaData.dbTypeId;
            const env = _.find(this.store.getState().projects.projectWithMetaData.autoDriftDetectionEnvTypes, (item) => {
                return envType.id == item.id
            });
            if (env) {
                return env.isEnabled;
            }
        }
        return false;
    }

    saveDraft() {
        this.undoChangesFlag = false;
        this.projectData.userInitiatedChange = true;
        this.store.dispatch({ type: projectActions.SAVE_DRAFT, payload: { project: this.projectData } }).then((resp) => {
            if (resp.data.validationErrors == null) {
                if (resp.data.projectDraft.id != 0 && (this.projectData == null || this.projectData.id == 0)) {
                    this.projectData = resp.data.projectDraft
                }
                this.store.dispatch({
                    type: projectActions.SET_EDIT_MODE,
                    payload: { editMode: true, isNewDraft: false }
                });
                this.store.dispatch({ type: projectActions.ACTION_CLEAR });
                this.store.dispatch({ type: projectActions.SAVE_PROJECT_BEFORE_EDIT, payload: resp.data.projectDraft });
                this.store.dispatch({ type: projectActions.UPDATE_PROJECT, payload: { project: resp.data.projectDraft } });

                this.showSchemaSettings = false;
                this.dialogManagerService.showSuccessDialog({
                    title: this.$translate('SUCCESS_PROJECT_DRAFT_SAVE'),
                    text: ''
                });
            } else {
                this.dialogManagerService.showErrorDialog({
                    title: this.$translate('ERROR_OCCURRED'),
                    text: (resp.data.validationErrors[0]['ErrorMsg']) ? resp.data.validationErrors[0]['ErrorMsg'] : ''
                });
            }
        })
    }

    updateVariablesMessage() {
        if (!this.projectData.parentId) {
            return;
        }
        let newEnvironments = [];
        this.projectData.environmentTypes.forEach((envType) => {
            const newEnv = envType.environments.filter(env => env.parentId === null);
            newEnvironments = [...newEnvironments, ...newEnv];
        })
        if (newEnvironments.length === 0) {
            return;
        }
        this.store.dispatch({ type: projectActions.GET_USER_DEFINED, payload: { projectId: this.projectData.parentId } })
            .then((variables) => {
                if (variables && variables.length > 0) {
                    const needToUpdate = variables.filter(variable => !variable.defaultValue || this.isFieldEmpty(variable.defaultValue))
                    if (needToUpdate.length === 0) {
                        return;
                    }
                    const newEnvNames = newEnvironments.map((env, i, arr) => arr.length - 1 === i ? env.name : env.name + ', ');
                    const environmentsName = needToUpdate.map((v, i, arr) => arr.length - 1 === i ? v.name : v.name + ', ');
                    this.dialogManagerService.showSuccessDialog({
                        title: 'Update Project Variables',
                        text: `Need validate new environment ${newEnvNames} and add value to ${environmentsName} variables.`,
                    });
                }
            });
    }

    isFieldEmpty(str) {
        return !str || str.toString().trim().length === 0;
    }

    saveChanges() { //this is publish
        const uuid = this.readCookie("uuid_client");
        this.logsLocalHistoryService.DeleteHistory(uuid);
        this.undoChangesFlag = false;
        this.store.dispatch({
            type: projectActions.COMMIT_PROJECT, payload: { project: this.projectData },
            callback: (response) => {
                if (response.data.validationErrors == null) {

                    //before saving the project a message will appear explaining it - happens from environments
                    this.dialogManagerService.showSuccessDialog({
                        title: this.$translate('PUBLISH_PROJECT_TITLE'),
                        text: this.$translate('PUBLISH_PROJECT_MSG'),
                    }, () => {
                        this.updateVariablesMessage();
                    });

                    this.store.dispatch({ type: projectActions.SET_EDIT_MODE, payload: { editMode: false } });
                    this.store.dispatch({ type: projectActions.SAVE_PROJECT_BEFORE_EDIT, payload: this.projectData });
                    if (this.firstTimeOnEditMode)
                        this.firstTimeOnEditMode = false;
                    setTimeout(() => this.m_getEnvTypes(), 50);
                    this.showSchemaSettings = false;
                    this.store.dispatch({ type: projectsActions.GET_PROJECTS });

                    if (!this.projectData.parentId) {
                        this.state.go(this.state.current.name, { id: this.projectData.id, name: this.projectData.name });
                        this.store.dispatch({
                            type: projectActions.SET_EDIT_MODE,
                            payload: { editMode: false, isNew: null }
                        });
                    } else {

                        //remain projectId and not parentId while staying in editmode
                        this.sessionService.set(`project_${this.projectData.id}`, this.projectData.name + ' (Draft)');
                        this.state.go(this.state.current.name, {
                            id: this.projectData.id,
                            name: this.projectData.name + ' (Draft)'
                        });

                        this.store.dispatch({
                            type: projectActions.SET_EDIT_MODE,
                            payload: { editMode: true, isNewDraft: false }
                        });
                    }
                } else {
                    this.dialogManagerService.showErrorDialog({
                        title: this.$translate('ERROR_OCCURRED'),
                        text: (response.data.validationErrors[0]['ErrorMsg']) ? response.data.validationErrors[0]['ErrorMsg'] : ''
                    });
                }
            }
        }).then(() => {
            this.store.dispatch({ type: licenseActions.GET_LICENSE_WARNINGS });
        });
    }

    onClose() {
        setTimeout(() => {
            this.store.dispatch({ type: projectActions.HIDE_MANAGE_ENVIRONMENT_ON_EDIT_MODE, payload: { hideManageEnv: "false" } });
            this.isHideManageEnvTypes = 'false';
            this.showSchemaSettings = false;
            if (this.projectData && !this.store.getState().project.editMode && !this.undoChangesFlag) {
                this.store.dispatch({ type: projectActions.UPDATE_PROJECT, payload: { project: this.projectData } });
            }
            this.undoChangesFlag = false;
            this.$scope.$apply();
        }, 1);
    }

    readCookie = (name) => {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    envTypeClickedTest($index) {
        this.store.dispatch({ type: projectActions.HIDE_MANAGE_ENVIRONMENT_ON_EDIT_MODE, payload: { hideManageEnv: "true" } });
        this.isHideManageEnvTypes = 'true';
        let targetIndex = $index;
        let selectedEnvType = this.envTypes[targetIndex];
        if (!selectedEnvType.isRMSource) {
            //CHECK IF RM SOURCE IS ALREADY HAVE AT LEAST ONE SCHEMA
            let rmSourceEnvType = this.envTypes.filter(i => i.isRMSource)[0];
            let rmSourceEnv = rmSourceEnvType.environments[0];
            if (rmSourceEnv.schemas == null || rmSourceEnv.schemas.length == 0) {
                targetIndex = this.envTypes.indexOf(rmSourceEnvType);
            }
        }
        this.currEnvTypeIndex = targetIndex;
        this.showSchemaSettings = true;
    }

    envTypeClicked($index) {
        this.store.dispatch({ type: projectActions.HIDE_MANAGE_ENVIRONMENT_ON_EDIT_MODE, payload: { hideManageEnv: "true" } });
        if ($index > 0 && this.envTypeTest && this.envTypeTest.environments.length > 0)
            $index = $index + 1;
        this.isHideManageEnvTypes = 'true';
        let targetIndex = $index;
        let selectedEnvType = ($index == this.envTypes.length) ? this.envTypes[targetIndex - 1] : this.envTypes[targetIndex];
        if (!selectedEnvType.isRMSource) {
            //CHECK IF RM SOURCE IS ALREADY HAVE AT LEAST ONE SCHEMA
            let rmSourceEnvType = this.envTypes.filter(i => i.isRMSource)[0];
            let rmSourceEnv = rmSourceEnvType.environments[0];
            if (rmSourceEnv.schemas == null || rmSourceEnv.schemas.length == 0) {
                targetIndex = this.envTypes.indexOf(rmSourceEnvType);
            }
        }
        if ($index == 0 && selectedEnvType.isRMSource && this.envTypeTest && this.envTypeTest.environments.length > 0)
            targetIndex = targetIndex + 1;
        this.currEnvTypeIndex = targetIndex;
        this.showSchemaSettings = true;
    }

    async onManageEnvTypes() {
        if (!this.projectData) {
            this.store.dispatch({ type: projectActions.ACTION_CLEAR });
        }

        let envs = [...this.projectData.environmentTypes];


        const onConfirm = (data) => {
            if (data) { }
            let deleteTypes = _.differenceBy(envs, this.projectData.environmentTypes, 'selected');

            deleteTypes = deleteTypes.filter(env => env.selected === false);

            // case is 0 mean a. no change - this ok , b. something been delete means there is object type change need check this
            if (deleteTypes.length === 0) {
                const _this = this;
                _.each(envs, (itemA, k) => {
                    const itemB = _this.projectData.environmentTypes[k];
                    if (!itemA.selected && itemA.selected != itemB.selected)
                        deleteTypes.push(itemA);
                });
            }

            if (deleteTypes && deleteTypes.length > 0) {
                const onConfirm = () => {
                    this.projectData.environmentTypes = envs;
                    //delete envs from environmentTypes are deleted
                    deleteTypes.forEach(envDeleted => {
                        this.projectData.environmentTypes.forEach(item => {
                            if (item.id === envDeleted.id)
                                item.environments = [];
                        });
                    });

                    if (this.projectData) {
                        this.store.dispatch({
                            type: projectActions.UPDATE_PROJECT,
                            payload: { project: this.projectData }
                        });
                    }
                };
                const dialogData = { title: 'Delete Environment', action: 'delete', objectType: 'environment(s)', item: '' };
                this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
            } else {
                this.projectData.environmentTypes = envs;
                if (this.projectData) {
                    this.store.dispatch({ type: projectActions.UPDATE_PROJECT, payload: { project: this.projectData } });
                }
            }

        }
        const dialogData = {
            title: 'Manage Environment Types',
            envTypes: envs,
            consts: consts,
            templates: this.store.getState().project.templates
        };
        this.dialogManagerService.showDialog(dialogData, onConfirm, ManageEnvironmentTypesDialogComponent, 'env-type-dialog');

    }

    setBoxed() {
        this.boxes = this.projectData.environmentTypes.filter(item => item.selected)
    }

    rotateLeft() {
        this.setBoxed();
        if (this.currEnvTypeIndex == 0)
            this.currEnvTypeIndex = this.boxes.length - 1 - this.currEnvTypeIndex;
        else
            this.currEnvTypeIndex = (--this.currEnvTypeIndex) % this.boxes.length;

    }

    rotateRight() {
        this.setBoxed();
        this.currEnvTypeIndex = (++this.currEnvTypeIndex) % this.boxes.length;

    }


    ngOnDestroy(): void {
        this.store.dispatch({ type: projectActions.RESET_SCHEMAS_LIST });
        this.store.dispatch({ type: projectActions.RESET_AVAILABLE_SCHEMAS_LIST });
        if (this.store.getState().project.editMode && this.projectData) {
            this.onClose();
        } else if (!this.store.getState().project.editMode) {
            this.store.dispatch({ type: projectActions.REMOVE_PROJECT_DATA });
            this.store.dispatch({ type: projectActions.REMOVE_PROJECT_BEFORE_EDIT });
        }


        this.destroyChild();
        this.destroyed = true;
    }



    trackByEnvType(_index, item) {
        return item.id;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/pipeline/pipleline-ang7.ts